import { render } from "./registrationinformation.vue?vue&type=template&id=620b4eca&scoped=true"
import script from "./registrationinformation.vue?vue&type=script&lang=js"
export * from "./registrationinformation.vue?vue&type=script&lang=js"

import "./registrationinformation.vue?vue&type=style&index=0&id=620b4eca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620b4eca"]])

export default __exports__